import React, { useEffect, useState } from "react";
import "./css/home.css";
import { useNavigate } from "react-router-dom";
import Layout from "./layout/Layout";
import gameConfig from "../utils/gamesConfig";
import SwiperE2 from "./swiperE2";
import SwiperTopTen from "./swipertopten";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./css/carousel.css";
import {
  service,
  brandImages,
  footerImages,
  backgroundImages,
  featureImages,
  getSectionBackgroundStyle,
  serviceName,
  PopupSub,
} from "../utils/constant";
import { useTranslation } from "react-i18next";
import { checkStatus, updateRenewalStatus } from "../services/user-api";

const Home = () => {
  const { t } = useTranslation("global");
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();
  const [subStatus, setSubStatus] = useState(0);
  const [popup, setPopup] = useState(false);
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" && window.innerWidth < 768,
  );

  const handlePlayGame = (input) => {
    setPopup(false);
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
    } 
    else{
      if (input !== null && input !== undefined && input.length > 2) {
        window.location.href = input;
      } else {
        navigate("/allGames");
      }
    }
    /*else {
      checkStatus()
        .then((res) => {
          if (res.data.data === 206) {
            setSubStatus(res.data.data);
            setPopup(true);
          } else if (input !== null && input !== undefined && input.length > 2) {
            window.location.href = input;
          } else {
            navigate("/allGames");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }*/
  };

  const renewalStatus = async (input) => {
    await updateRenewalStatus({ status: input })
      .then((res) => {
        setPopup(false);
        console.log(res);
      })
      .catch((err) => {
        setPopup(false);
        console.log(err);
      });
  };

  const adventureGames = gameConfig.find(
    (item) => item.category_name === "Adventure",
  );

  const racingGames = gameConfig.find(
    (item) => item.category_name === "Racing",
  );
  const sportGames = gameConfig.find((item) => item.category_name === "Sports");
  const funnyGames = gameConfig.find((item) => item.category_name === "Funny");

  const actionGames = gameConfig.find(
    (item) => item.category_name === "Action",
  );
  const puzzleGames = gameConfig.find(
    (item) => item.category_name === "Puzzle",
  );
  const kidsGames = gameConfig.find((item) => item.category_name === "Kids");
  const androidGames = gameConfig.find(
    (item) => item.category_name === "Android",
  );

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 6,
    autoplay: true,
    autoplaySpeed: 1500,
    responsive: [
      {
        breakpoint: 768, // Adjust the breakpoint as needed
        settings: {
          slidesToShow: 2, // Show 2 slides at a time on mobile devices
          slidesToScroll: 2,
        },
      },
    ],
  };

  const topTenSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1500,
    responsive: [
      {
        breakpoint: 768, // Adjust the breakpoint as needed
        settings: {
          slidesToShow: 2, // Show 2 slides at a time on mobile devices
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1196, // Adjust the breakpoint as needed
        settings: {
          slidesToShow: 3, // Show 2 slides at a time on mobile devices
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1400, // Adjust the breakpoint as needed
        settings: {
          slidesToShow: 4, // Show 2 slides at a time on mobile devices
          slidesToScroll: 1,
        },
      },
    ],
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    const sections = document.querySelectorAll(".home_page .reveal-on-scroll");
    if (!sections.length) return undefined;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" },
    );

    sections.forEach((section) => observer.observe(section));
    return () => observer.disconnect();
  }, []);

  return (
    <Layout>
      <div className="home_page page_shell">
        <section
          className="intro_part section_bg"
          style={getSectionBackgroundStyle(
            isMobile ? backgroundImages.heroMobile : backgroundImages.hero,
            { overlay: 0.75, position: "center top" },
          )}
        >
          <div className="hero_orb hero_orb--cyan" aria-hidden="true" />
          <div className="hero_orb hero_orb--purple" aria-hidden="true" />
          <div className="container">
            <div className="row align-items-center">
              <div className="col-12 col-lg-5">
                <div className="intro_text_container hero-animate">
                  <div className="hero_badge">
                    <i className="fas fa-gamepad"></i>
                    {t("portalText.play")}
                  </div>
                  {service === "mueg" ? (
                    <h2>
                      Muni <span>Game</span>
                    </h2>
                  ) : service === "mng" ||
                    service === "mtg" ||
                    service === "mgb" ? (
                    <h2>
                      MOOV <span>GAMES</span>
                    </h2>
                  ) : (
                    <h2>
                      GS <span>GAMES</span>
                    </h2>
                  )}
                  <p>
                    {service === "ogb" ? (
                      <>
                        {t("portalText.ogbDesc")}
                        <img
                          className="ogMoney"
                          src="/images/ogg.png"
                          alt="GSGames"
                        />
                        {t("portalText.ogbDesc1")}
                      </>
                    ) : service === "mng" ? (
                      t("portalText.mngDesc")
                    ) : service === "mtg" ? (
                      t("portalText.mtgDesc")
                    ) : service === "mgb" ? (
                      t("portalText.mgbDesc")
                    ) : service === "mueg" ? (
                      t("portalText.muegDesc")
                    ) : (
                      t("portalText.desc")
                    )}
                  </p>
                  <button
                    className="btn_play"
                    onClick={() => handlePlayGame("/allGames")}
                  >
                    <i className="fas fa-play"></i>
                    <span>{t("portalText.play")}</span>
                  </button>
                </div>
              </div>
              <div className="col-12 col-lg-7 hero_visual">
                <div className="hero_visual_card">
                  <img src={featureImages.gamer} alt="GS Games" />
                </div>
                <div className="hero_stats">
                  <div className="stat_chip">
                    <strong>1000+</strong>
                    <span>{t("portalText.Games")}</span>
                  </div>
                  <div className="stat_chip">
                    <strong>8</strong>
                    <span>{t("portalText.play")}</span>
                  </div>
                  <div className="stat_chip">
                    <strong>24/7</strong>
                    <span>Online</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="brand_list reveal-on-scroll">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-12 col-lg-12">
                <Slider {...settings}>
                  {brandImages.map((brand, index) => (
                    <img
                      key={`BrandSlide ${index + 1}`}
                      src={brand.src}
                      alt={brand.name}
                    />
                  ))}
                </Slider>
              </div>
            </div>
          </div>
        </section>
      {/*  <section
          className="games_1 section_bg reveal-on-scroll"
          style={getSectionBackgroundStyle(backgroundImages.action, {
            overlay: 0.85,
          })}
        >
          <div className="container section_block section_block--tight">
            <div className="section_head">
              <div>
                <span className="section_eyebrow">{t("portalText.action")}</span>
                <h3 className="section_title">{t("portalText.play")}</h3>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <SwiperE2 gameData={actionGames} playGame={handlePlayGame} />
              </div>
              <div className="col-12">
                <SwiperE2 gameData={adventureGames} playGame={handlePlayGame} />
              </div>
            </div>
          </div>
        </section> */}
        <section
          className="top_games section_bg reveal-on-scroll"
          style={getSectionBackgroundStyle(backgroundImages.topGames, {
            overlay: 0.8,
          })}
        >
          <div className="container">
            <div className="row align-items-center">
              <div className="col-12 col-lg-8">
                <div className="section_header">
                  <h4>
                    {t("portalText.Top 10")}
                    <span> {t("portalText.Games")}</span>
                  </h4>
                  <div className="section_divider"></div>
                </div>

                {/* for tablet and desktop  */}
                {/* <div className="row align-items-center mb-4 topten-tablet-desktop">
                    {top5Games.length > 0 &&
                      top5Games.map((game) => {
                        return (
                          <div className="col-12 col-sm-2" key={game.name}>
                            <div className="top_game_wrapper">
                              <a href={game.path}>
                                <div className="top_games_img">
                                  <img src={game.image} alt={game.name} />
                                </div>
                              </a>
                              <div className="top_game_title">{game.name}</div>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                  <div className="row align-items-center topten-tablet-desktop">
                    {top10Games.length > 0 &&
                      top10Games.map((game) => {
                        return (
                          <div className="col-12 col-sm-2" key={game.name}>
                            <div className="top_game_wrapper">
                              <a href={game.path}>
                                <div className="top_games_img">
                                  <img src={game.image} alt={game.name} />
                                </div>
                              </a>
                              <div className="top_game_title">{game.name}</div>
                            </div>
                          </div>
                        );
                      })}
                  </div> */}
                {/* for mobile  */}
                <div className="topten-mobile">
                  <SwiperTopTen playGame={handlePlayGame} />
                </div>
              </div>
              <div className="col-12 col-lg-4">
                <div className="hero_feature_card just_gamer_img">
                  <img src={featureImages.gamer} alt="GS Games player" />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          className="games_2 section_bg reveal-on-scroll"
          style={getSectionBackgroundStyle(backgroundImages.puzzle, {
            overlay: 0.86,
          })}
        >
          <div className="container">
            <div className="row">
              <div className="col-12">
                <SwiperE2 gameData={puzzleGames} playGame={handlePlayGame} />
              </div>
              <div className="col-12">
                <SwiperE2 gameData={funnyGames} playGame={handlePlayGame} />
              </div>
            </div>
          </div>
        </section>
        <section
          className="uv_played section_bg reveal-on-scroll"
          style={getSectionBackgroundStyle(backgroundImages.cta, {
            overlay: 0.78,
          })}
        >
          <div className="container">
            <div className="row align-items-center">
              <div className="col-12 col-md-4">
                <div className="hero_feature_card uv_played_img">
                  <img src={featureImages.champion} alt="GS Games champion" />
                </div>
              </div>
              <div className="col-12 col-md-8">
                <div className="uv_played_text">
                  <div className="uv_played_title">
                    {service === "mueg"
                      ? t("portalText.MuniGames") + " " + currentYear
                      : t("portalText.GS Games") + " " + currentYear}
                  </div>
                  <button
                    type="button"
                    className="uv_played_btn"
                    onClick={() => handlePlayGame("/allGames")}
                  >
                    {service === "mueg"
                      ? t("portalText.TryMuni") + " " + currentYear
                      : t("portalText.Try UV") + " " + currentYear}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          className="games_3 section_bg reveal-on-scroll"
          style={getSectionBackgroundStyle(backgroundImages.racing, {
            overlay: 0.84,
          })}
        >
          <div className="container">
            <div className="row">
              <div className="col-12">
                <SwiperE2 gameData={racingGames} playGame={handlePlayGame} />
              </div>
              <div className="col-12">
                <SwiperE2 gameData={kidsGames} playGame={handlePlayGame} />
              </div>
            </div>
          </div>
        </section>
        <section
          className="games_4 section_bg reveal-on-scroll"
          style={getSectionBackgroundStyle(backgroundImages.sports, {
            overlay: 0.86,
          })}
        >
          <div className="container">
            <div className="row">
              <div className="col-12">
                <SwiperE2 gameData={sportGames} playGame={handlePlayGame} />
              </div>
              {/* <div className='col-12'>
                                <SwiperEl title='arcade' />
                            </div> */}
            </div>
          </div>
        </section>
        <section
          className="games_4 section_bg reveal-on-scroll"
          style={getSectionBackgroundStyle(backgroundImages.android, {
            overlay: 0.86,
          })}
        >
          <div className="container">
            <div className="row">
              <div className="col-12">
                <SwiperE2 gameData={androidGames} playGame={handlePlayGame} />
              </div>
              {/* <div className='col-12'>
                                <SwiperEl title='arcade' />
                            </div> */}
            </div>
          </div>
        </section>
        <section className="brand_list brand_list_footer reveal-on-scroll">
          <div className="container">
            <div className="row align-items-center">
              {/* <div className='col-12 col-lg-4 d-none d-lg-block'>
                                <p>Trusted By Brands Worldwide:</p>
                            </div> */}
              <div className="col-12 col-lg-12">
                <Slider {...topTenSettings}>
                  {footerImages.map((brand, index) => (
                    <img
                      key={`FooterSlide ${index + 1}`}
                      src={brand.src}
                      alt={brand.name}
                    />
                  ))}
                </Slider>
              </div>
            </div>
          </div>
        </section>
        <footer className="site_footer">
          <div className="container site_footer_inner">
            
            <div className="site_footer_divider" />
            <p className="site_footer_copy">
              {t("portalText.Copyright") + currentYear + " " + serviceName}
            </p>
          </div>
        </footer>
      </div>
      {popup && (
        <PopupSub
          subStatus={subStatus}
          redirectTo={renewalStatus}
          detail={t("portalText.RenewalConsent")}
          confirm={t("portalText.RenewalConsent1")}
          yes={t("portalText.YES")}
          no={t("portalText.NO")}
        />
      )}
    </Layout>
  );
};

export default Home;
